import React, {Component} from 'react';
import '../../styles/Home.css'
import {Button} from "react-bootstrap";
import LoginService from "../../admin/loginComponents/LoginService";
import {Link, withRouter} from "react-router-dom";
import Konto from "../Konto";
import {NotificationManager} from "react-notifications";

class PasswordLostComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            lostPassEmail: '',
            loading: false,
        };

        this.handleLostPassEmail = this.handleLostPassEmail.bind(this);
    }

    componentDidMount() {
        this.nameInput.focus();
    }

    handleLogin(e) {
        this.setState({login: e.target.value})
    }

    handlePass(e) {
        this.setState({pass: e.target.value})
    }

    handleLostPassEmail(e) {
        this.setState({lostPassEmail: e.target.value})
    }

    resetPassword() {
        this.setState({loading: true})
        LoginService.resetHasla(this.state.lostPassEmail)
            .then(function (response) {
                if (response.status === 200) {
                    NotificationManager.success("", 'Link resetujący hasło został wysłany na podany adres e-mail', 10000)
                    this.setState({loading: false, lostPassEmail: ''})
                }
            }.bind(this))
            .catch(error => {
                console.log(error)
            })
    }

    render() {
        return <Konto>
            <div className="row wynik ramka marginLeftRightMobilka" style={{padding: 50}}>

                <div className="col-12 text-center">
                    <h2><b>Przypomnienie hasła</b></h2>
                    <p style={{fontSize: '0.875rem', paddingTop: '10px', marginBottom: '10px'}}>Aby wygenerować nowe
                        hasło należy podać adres e-mail używany do logowania w witrynie.</p>
                    <div className="inputLogin"><i className="fa fa-envelope"> </i>
                        <input className="form-control inputLoginControl"
                               ref={(input) => {
                                   this.nameInput = input;
                               }}
                               value={this.state.lostPassEmail}
                               onChange={this.handleLostPassEmail}
                               placeholder="Adres e-mail..."
                               type="text"/></div>
                    <div className="buttonLogin" style={{marginTop: 10}}><Button bsStyle="success"
                                                                                 onClick={() => this.resetPassword()}>Resetuj
                        hasło</Button>
                    </div>
                    {this.state.loading ? <div className="loaderDim" style={{marginTop: 5}}><i
                        className="fa fa-spinner fa-pulse fa-fw"
                        style={{
                            color: '#58b13d'
                        }}> </i></div> : null}
                    <div style={{paddingTop: 15, cursor: 'pointer'}}>Powrót do <Link
                        to={'/login'}><b>logowania</b></Link></div>
                </div>
            </div>
        </Konto>
    }

}

export default withRouter(PasswordLostComponent)



// WEBPACK FOOTER //
// ./src/components/konto/kontoComponents/PasswordLostComponent.js